import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import moment from 'moment';
import { HelpersService } from '../../../../../services/helpers.service';
import { RentalsService } from '../../../../../services/rentals.service';
import { AppConfig } from '../../../../../app.config';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { EventInput, Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import resourceDayGridPlugin from '@fullcalendar/resource-daygrid';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';


@Component({
  selector: 'app-reservations',
  templateUrl: './reservations.component.html',
  styleUrls: ['./reservations.component.scss'],
  providers: [MessageService],
})
export class ReservationsComponent implements OnInit {
  public nowTime: any = new Date();
  public partnerData: any = {};
  public partnerID: number = 0;
  public rentalProductsRaw: any = [];
  public rentalProducts: any = [];
  public contentHeight: number = 400;
  public loading: boolean = false;
  public categories: any = [];
  public selectedCategories: string[] = [];
  public brands: any = [];
  public selectedBrands: string[] = [];
  public sizes: any = [];
  public selectedSizes: string[] = [];
  public showBookRentalReservation: boolean = false;
  public showRentalReservation: boolean = false;
  public bookingInfo: any = {};
  public selectedReservation: any = {};
  public enableSearch: boolean = false;
  public searching: boolean = false;
  public searchRequest: any;
  public searchResults: any = [];
  public selectedSearchOption: string = 'JOBCARD';
  public rentalsConfigured: boolean = false;
  public loadingConfig: boolean = false;
  public showFilter: boolean = false;
  public rentalStoreRules: any = {};
  public showRentalProduct: boolean = false;
  public selectedProduct: any = {};
  public affiliates: any = [];
  public hideProductImages: boolean = false;
  public selectedAffiliates: any = [];
  public showDeliveries: boolean = false;
  public showNonDeliveries: boolean = false;
  public calendarData: any = [];
  public affiliateReservationList: any = [];

  @ViewChild('searchtextbox') searchElement: ElementRef;

  calendarVisible = true;
  calendarPlugins = [
    resourceDayGridPlugin,
    resourceTimeGridPlugin,
    resourceTimelinePlugin,
    dayGridPlugin,
    timeGridPlugin,
    interactionPlugin,
  ];

  calendarWeekends = true;
  minTime = '00:00:00';
  maxTime = '24:00:00';
  calendarEvents: EventInput[] = [];
  event: any = [];
  public daysOfWeek = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ];
  public calendarApi: Calendar;
  public calendarButtonText = {
    today: 'today',
    month: 'month',
    week: 'week',
    day: 'day',
  };
  public calendarViews: any = {
    Month: {
      // type: 'dayGridMonth',
      // titleFormat: { day: 'numeric', month: 'short', year: 'numeric', weekday: 'short' }
      type: 'resourceTimelineMonth',
      titleFormat: {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        weekday: 'short',
      },
      resourceAreaWidth: '200px',
      slotLabelInterval: { days: 1 },
      slotDuration: { days: 1 },
      //slotWidth: '70'
    },
    Week: {
      type: 'resourceTimelineWeek',
      titleFormat: {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        weekday: 'short',
      },
      resourceAreaWidth: '200px',
      slotLabelInterval: { days: 1 },
      slotDuration: { days: 1 },
      scrollTime: { Duration: '00:00:00' },
    },
    Day: {
      type: 'resourceTimelineDay',
      titleFormat: {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        weekday: 'short',
      },
      resourceAreaWidth: '200px',
      slotLabelInterval: '01:00:00',
      slotDuration: { minutes: 60 },
      scrollTime: { Duration: '00:00:00' },
    },
  };

  @ViewChild('calendar') calendarComponent: FullCalendarComponent;
  headerView = 'Day, Week, Month';

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.contentHeight = window.innerHeight - 160;
  }

  constructor(
    private helpersService: HelpersService,
    private rentalsService: RentalsService,
    private appConfig: AppConfig,
    private translate: TranslateService,
    private router: Router,
    public messageService: MessageService
  ) { }

  ngOnInit() {
    this.partnerID = this.helpersService.getPartnerId();
    this.partnerData = this.helpersService.getPartnerData();
    this.getRentalConfig();
    this.getAffiliates();

    this.calendarButtonText = {
      today: this.translate.instant('bikeshop.calendar.today'),
      month: this.translate.instant('bikeshop.calendar.month'),
      week: this.translate.instant('bikeshop.calendar.week'),
      day: this.translate.instant('bikeshop.calendar.day'),
    };
  }

  getRentalConfig() {
    this.loadingConfig = true;
    this.rentalsService
      .getRentalConfiguration(this.helpersService.getPartnerId())
      .subscribe((config) => {
        this.rentalStoreRules = config;
        this.calendarViews.Day.slotDuration.minutes =
          config.calendarDayViewInterval;
        /*var MINUTES = config.calendarDayViewInterval; //some integer
                                            var m = MINUTES % 60;
                                            var h = (MINUTES-m)/60;
                                            var HHMM = (h < 10 ? "0" : "") + h.toString() + ":" + (m < 10 ? "0" : "") + m.toString();
                                            this.calendarViews.Day.slotLabelInterval = HHMM;*/

        this.getRentalProducts();

        if (config && config.defaultStoreTimes) {
          config.defaultStoreTimes.forEach((x) => {
            if (x.isWorking) {
              this.rentalsConfigured = true;
            }
          });
        }

        if (!this.rentalsConfigured) {
          this.router.navigateByUrl('store/rentals/reservations-tour');
        }
      });
  }

  ngAfterViewInit() {
    this.calendarApi = this.calendarComponent.getApi();
    this.addCalendarEventSource();
    this.setCalendarRefresh();
    //this.setView();
    this.calendarApi.setOption('locale', this.appConfig.getLocale());
  }

  ngAfterContentInit() {
    this.contentHeight = window.innerHeight - 160;
  }

  renderView(element, view) {
    if (this.calendarApi) {
    }
  }

  getRentalProducts() {
    this.loading = true;
    this.rentalsService.getActiveRentalProducts(this.partnerID).subscribe(
      (res) => {
        this.createFilterData(res);
        this.rentalProducts = res.map((product,index) => {
          return {
            id: product.id,
            title: product.brand + ' ' + product.model,
            sortIndex : index,
            extendedProps: { ...product },
            businessHours: [],
            statusID: product.statusID,
            status: product.status
          };
        });
        this.rentalProductsRaw = this.rentalProducts;
        this.setBusinessHours(this.rentalProducts);
        this.loading = false;
      },
      (err) => {
        this.loading = false;
        this.loadingConfig = false;
      },
    );
  }

  setBusinessHours(products) {
    var minTime = '24:00:00';
    var maxTime = '00:00:00';
    products.forEach((product) => {
      this.rentalStoreRules.defaultStoreTimes.forEach((time) => {

        const adjustedStartTime = time.startTime != null && time.startTime != "00:00:00" ? moment(time.startTime, 'HH:mm:ss')
          .subtract(1, 'hour')
          .format('HH:mm:ss') : "00:00:00";

        if (time.isWorking && adjustedStartTime < minTime) {
          minTime = adjustedStartTime;
        }
        if (time.isWorking && time.endTime != "00:00:00" && time.endTime > maxTime) {
          maxTime = time.endTime;
        }
        //product.businessHours.push({ daysOfWeek: [time.dayOfWeek], startTime: time.startTime || "00:00:00", endTime: time.endTime || "00:00:00" });
        var daysOfWeek = product.businessHours.map((x) => {
          return x.daysOfWeek[0];
        });
        var index = daysOfWeek.indexOf(time.dayOfWeek);
        if (index > -1) {
          product.businessHours.splice(index, 1);
          if (product.statusID == 40) {
            //Do nothing here...
          } else {
            product.businessHours.push({
              daysOfWeek: [time.dayOfWeek],
              startTime: time.startTime || '00:00:00',
              endTime: time.endTime || '00:00:00',
            });
          }
        } else {
          if (product.statusID == 40) {
            //Do nothing here...
          } else {
            product.businessHours.push({
              daysOfWeek: [time.dayOfWeek],
              startTime: time.startTime || '00:00:00',
              endTime: time.endTime || '00:00:00',
            });
          }
        }
      });

      if (product.statusID === 40 && product.businessHours.length === 0) {
        product.businessHours.push({
          daysOfWeek: [8],
          startTime: '00:00:00',
          endTime: '00:00:00',
        });
      }

    });
    this.minTime = minTime;
    this.maxTime = maxTime;
    if (this.minTime !== '24:00:00' && this.maxTime !== '00:00:00') {
      this.rentalsConfigured = true;
    } else {
      this.rentalsConfigured = false;
    }
    this.loadingConfig = false;
  }

  setCustomBusinessHours(overrideStoreTimes) {
    this.rentalProducts.forEach((product) => {
      overrideStoreTimes.forEach((time) => {
        var daysOfWeek = product.businessHours.map((x) => {
          return x.daysOfWeek[0];
        });


        var index = daysOfWeek.indexOf(time.dayOfWeek);
        if (index > -1) {
          product.businessHours.splice(index, 1);
          product.businessHours.push({
            daysOfWeek: [time.dayOfWeek],
            startTime: time.startTime || '00:00:00',
            endTime: time.endTime || '00:00:00',
          });
        } else {
          product.businessHours.push({
            daysOfWeek: [time.dayOfWeek],
            startTime: time.startTime || '00:00:00',
            endTime: time.endTime || '00:00:00',
          });
        }
      });
    });
  }

  createFilterData(results) {
    this.categories = results
      .map((product) => {
        return product.categoryName;
      })
      .filter(
        (v, i, a) =>
          a
            .map((x) => {
              return x;
            })
            .indexOf(v) === i,
      )
      .sort((x, y) => {
        if (x > y) return 1;
        if (x < y) return -1;
        return 0;
      });
    this.brands = results
      .map((product) => {
        return product.brand;
      })
      .filter(
        (v, i, a) =>
          a
            .map((x) => {
              return x;
            })
            .indexOf(v) === i,
      )
      .sort((x, y) => {
        if (x > y) return 1;
        if (x < y) return -1;
        return 0;
      });
    this.sizes = results
      .map((product) => {
        return product.size;
      })
      .filter(
        (v, i, a) =>
          a
            .map((x) => {
              return x;
            })
            .indexOf(v) === i,
      )
      .sort((x, y) => {
        if (x > y) return 1;
        if (x < y) return -1;
        return 0;
      });
    if (results && results.length > 0) {
      this.showFilter = true;
    }
  }

  filterCalendarProducts() {
    this.rentalProducts = this.rentalProductsRaw;
    if (this.selectedCategories && this.selectedCategories.length > 0) {
      this.rentalProducts = this.rentalProducts.filter((x) => {
        return (
          this.selectedCategories.indexOf(x.extendedProps.categoryName) > -1
        );
      });
    }
    if (this.selectedBrands && this.selectedBrands.length > 0) {
      this.rentalProducts = this.rentalProducts.filter((x) => {
        return this.selectedBrands.indexOf(x.extendedProps.brand) > -1;
      });
    }
    if (this.selectedSizes && this.selectedSizes.length > 0) {
      this.rentalProducts = this.rentalProducts.filter((x) => {
        return this.selectedSizes.indexOf(x.extendedProps.size) > -1;
      });
    }

    if (this.selectedAffiliates && this.selectedAffiliates.length > 0) {
      var productList = this.calendarData.reservationData
        .filter((x) => {
          return (
            this.selectedAffiliates
              .map((y) => {
                return y.affiliateName;
              })
              .indexOf(x.affiliateName) > -1
          );
        })
        .map((x) => {
          return x.productID;
        });
      this.rentalProducts = this.rentalProducts.filter((x) => {
        return productList.indexOf(x.id) > -1;
      });
    }

    if (this.showDeliveries) {
      var productList = this.calendarData.reservationData
        .filter((x) => {
          return (
            x.deliveryInformation !== null || x.collectionInformation != null
          );
        })
        .map((x) => {
          return x.productID;
        });
      this.rentalProducts = this.rentalProducts.filter((x) => {
        return productList.indexOf(x.id) > -1;
      });
    }

    if (this.showNonDeliveries) {
      var productList = this.calendarData.reservationData
        .filter((x) => {
          return (
            x.deliveryInformation == null && x.collectionInformation == null
          );
        })
        .map((x) => {
          return x.productID;
        });
      this.rentalProducts = this.rentalProducts.filter((x) => {
        return productList.indexOf(x.id) > -1;
      });
    }
  }

  actionProductImages() {
    this.calendarApi.refetchResources();
  }

  dateRangeSelected(event) {
    this.bookingInfo = {
      fromDate: moment(
        moment.utc(event.startStr).format('YYYY-MM-DDTHH:mm:ss'),
      ).toDate(),
      toDate: moment(
        moment.utc(event.endStr).format('YYYY-MM-DDTHH:mm:ss'),
      ).toDate(),
      linkedRentalProducts: [],
      initiallySelectedProduct: parseInt(event.resource.id),
      deliveryInformation: {},
      collectionInformation: {},
      isDemo: event.resource.extendedProps.isDemo && !event.resource.extendedProps.isRental
    };
    this.showBookRentalReservation = true;
  }

  addCalendarEventSource() {
    this.calendarApi.addEventSource((event, callback) => {
      if (event.start !== this.event.start) {
        this.event = event;
        this.rentalsService
          .getReservationCalendarData(
            this.helpersService.getPartnerId(),
            moment.utc(event.start.toISOString()).format('YYYY-MM-DD'),
            moment.utc(event.end.toISOString()).format('YYYY-MM-DD'),
          )
          .subscribe((calendarData) => {
            // Store calendar data
            this.calendarData = calendarData;
            this.affiliateReservationList = calendarData.reservationData
              ? calendarData.reservationData
                .filter((x) => x.affiliateName != null)
                .map((x) => x.affiliateName)
              : [];

            // Build all events into an array
            const allEvents = [];

            // Add reservation events
            if (calendarData && calendarData.reservationData) {
              calendarData.reservationData.forEach((reservation) => {
                allEvents.push(this.buildReservationEvent(reservation));
              });
            }

            // Add service events
            if (calendarData && calendarData.serviceData) {
              calendarData.serviceData.forEach((service) => {
                allEvents.push(this.buildServiceEvent(service));
              });
            }

            // Add blocked events
            if (calendarData && calendarData.blockedData) {
              calendarData.blockedData.forEach((blocked) => {
                allEvents.push(this.buildBlockedEvent(blocked));
              });
            }

            // Return all events at once - let FullCalendar handle the diff
            callback(allEvents);
          });
      } else {
        callback([]);
      }
    });
  }

  private buildReservationEvent(reservation: any) {
    const today = moment().format('YYYY-MM-DDTHH:mm:ss');
    const startDate = moment.utc(reservation.fromDate + 'Z').format('YYYY-MM-DDTHH:mm:ssZ');
    const endDate = moment.utc(reservation.toDate + 'Z').format('YYYY-MM-DDTHH:mm:ssZ');

    return {
      groupId: reservation.id,
      id: reservation.id.toString(),
      resourceId: reservation.productID,
      technicianID: reservation.productID,
      title: reservation.customer,
      durationEditable: false,
      selectable: false,
      editable: false,
      start: startDate,
      end: endDate,
      affiliateName: reservation.affiliateName,
      className: this.getReservationClassName(reservation, endDate, today),
      // Store all props in extendedProps for renderEvent
      reservationNumber: reservation.reservationNumber,
      isDemo: reservation.isDemo,
      fromDate: reservation.fromDate,
      toDate: reservation.toDate,
      deliveryInformation: reservation.deliveryInformation,
      collectionInformation: reservation.collectionInformation,
      paymentStatus: reservation.paymentStatus,
      currencySymbol: reservation.currencySymbol,
      invoiceTotal: reservation.invoiceTotal,
      accessories: reservation.accessories,
      reservationStatus: reservation.reservationStatus
    };
  }

  private buildServiceEvent(service: any) {
    const startDate = moment.utc(service.fromDate + 'Z').format('YYYY-MM-DDTHH:mm:ssZ');
    const endDate = moment.utc(service.toDate + 'Z').format('YYYY-MM-DDTHH:mm:ssZ');

    return {
      groupId: service.serviceID,
      id: service.serviceID.toString(),
      resourceId: service.productID,
      technicianID: service.productID,
      title: service.brand + ' ' + service.model,
      durationEditable: false,
      selectable: false,
      editable: false,
      start: startDate,
      end: endDate,
      className: 'rental-service',
      // Store props needed for renderEvent
      serviceID: service.serviceID,
      jobCardID: service.jobCardID,
      fromDate: service.fromDate,
      toDate: service.toDate,
      serviceStatusID: service.serviceStatusID,
      serviceTypes: service.serviceTypes
    };
  }

  private buildBlockedEvent(blocked: any) {
    const startDate = moment.utc(blocked.fromDate + 'Z').format('YYYY-MM-DDTHH:mm:ssZ');
    const endDate = moment.utc(blocked.toDate + 'Z').format('YYYY-MM-DDTHH:mm:ssZ');

    return {
      groupId: blocked.serviceID,
      id: blocked.calendarEventID.toString(),
      resourceId: blocked.productID,
      technicianID: blocked.productID,
      title: blocked.description,
      durationEditable: false,
      selectable: false,
      editable: false,
      start: startDate,
      end: endDate,
      className: 'rental-reservation-blocked'
    };
  }

  private getReservationClassName(reservation: any, endDate: string, today: string): string {
    if (reservation.reservationStatusID === 1) return 'rental-reservation-booked';
    if (reservation.reservationStatusID === 2) return 'rental-delivery-booked';
    if (reservation.reservationStatusID === 10) return 'rental-reservation-being-prepared';
    if (reservation.reservationStatusID === 20) return 'rental-reservation-ready';
    if (reservation.reservationStatusID === 30) {
      return moment.utc(endDate).toDate() < moment.utc(today).toDate()
        ? 'rental-reservation-late'
        : 'rental-reservation-out';
    }
    if (reservation.reservationStatusID === 39) return 'rental-collection-booked';
    if (reservation.reservationStatusID === 40) return 'rental-reservation-being-checked';
    if (reservation.reservationStatusID === 50) return 'rental-reservation-returned';
    if (reservation.reservationStatusID === 51) return 'rental-reservation-collected';
    if (reservation.reservationStatusID === 100) return 'rental-reservation-canceled';
    return '';
  }


  renderEvent(info) {
    if (this.calendarApi && this.calendarApi.view.type !== 'Month') {
      if (info.event.extendedProps.reservationNumber) {
        if (info.event.title) {
          info.el.firstChild.innerHTML = `<div class='fc-other fc-customer'><span class="fa fa-user-o"></span>${info.event.title}</div>`;
        }
        if (info.event.extendedProps.reservationNumber) {
          if (info.event.extendedProps.isDemo) {
            info.el.firstChild.innerHTML += `<div class='fc-other fc-job'><span class="fa fa-hashtag"></span>${info.event.extendedProps.reservationNumber} (${this.translate.instant('bikeshop.rentals.booking.type_demo')})</div>`;
          } else {
            info.el.firstChild.innerHTML += `<div class='fc-other fc-job'><span class="fa fa-hashtag"></span>${info.event.extendedProps.reservationNumber}</div>`;
          }
        }
        if (info.event.extendedProps.affiliateName) {
          info.el.firstChild.innerHTML += `<div class='fc-other'><span class="fa hubtiger-shop-profile"></span>${info.event.extendedProps.affiliateName}</div>`;
        }
        if (
          info.event.extendedProps.fromDate &&
          !info.event.extendedProps.deliveryInformation
        ) {
          info.el.firstChild.innerHTML += `<div class='fc-other'><span class="fa fa-calendar-o"></span>${moment(info.event.extendedProps.fromDate).format('ha, Do MMM')} -> ${moment(info.event.extendedProps.toDate).format('ha, Do MMM')}</div>`;
        }
        if (info.event.extendedProps.deliveryInformation) {
          info.el.firstChild.innerHTML += `<div class='fc-other'><span class="fa fa-truck"></span><span class="fa fa-arrow-right"></span>${moment('1970-01-01T' + info.event.extendedProps.deliveryInformation.scheduleTimeSlotStart).format('ha')} - ${moment('1970-01-01T' + info.event.extendedProps.deliveryInformation.scheduleTimeSlotEnd).format('ha')}, ${moment(info.event.extendedProps.deliveryInformation.scheduleDate).format('Do MMM')}</div>`;
        }
        if (info.event.extendedProps.collectionInformation) {
          info.el.firstChild.innerHTML += `<div class='fc-other'><span class="fa fa-truck"></span><span class="fa fa-arrow-left"></span>${moment('1970-01-01T' + info.event.extendedProps.collectionInformation.scheduleTimeSlotStart).format('ha')} - ${moment('1970-01-01T' + info.event.extendedProps.collectionInformation.scheduleTimeSlotEnd).format('ha')}, ${moment(info.event.extendedProps.collectionInformation.scheduleDate).format('Do MMM')}</div>`;
        }
        if (
          info.event.extendedProps.fromDate &&
          info.event.extendedProps.deliveryInformation &&
          !info.event.extendedProps.collectionInformation
        ) {
          info.el.firstChild.innerHTML += `<div class='fc-other'><span class="fa fa-calendar-o"></span><span class="fa fa-arrow-left"></span>${moment(info.event.extendedProps.toDate).format('ha, Do MMM')}</div>`;
        }

        if (info.event.extendedProps.paymentStatus) {
          info.el.firstChild.innerHTML += `<div class='fc-other'><span class="fa fa-credit-card"></span>${info.event.extendedProps.currencySymbol}${info.event.extendedProps.invoiceTotal.toFixed(2)} - ${info.event.extendedProps.paymentStatus}</div>`;
        }
        if (info.event.extendedProps.accessories) {
          info.el.firstChild.innerHTML += `<div class='fc-other'><span class="fa fa-shopping-basket"></span>${info.event.extendedProps.accessories
            .map((x) => {
              return x.brand + ' ' + x.name;
            })
            .join(', ')}</div>`;
        }
      }
      if (info.event.extendedProps.serviceID) {
        if (info.event.title) {
          info.el.firstChild.innerHTML = `<div class='fc-other fc-customer'><span class="fa fa-gear"></span>${this.translate.instant('bikeshop.rentals.booking.booked_for_service')}</div>`;
        }
        if (info.event.extendedProps.jobCardID) {
          info.el.firstChild.innerHTML += `<div class='fc-other fc-job'><span class="fa fa-hashtag"></span>${info.event.extendedProps.jobCardID}</div>`;
        }
        if (info.event.extendedProps.fromDate) {
          info.el.firstChild.innerHTML += `<div class='fc-other'><span class="fa fa-calendar-o"></span>${moment(info.event.extendedProps.fromDate).format('ha, Do MMM')} - ${moment(info.event.extendedProps.toDate).format('ha, Do MMM')}</div>`;
        }
        if (info.event.extendedProps.serviceStatusID) {
          info.el.firstChild.innerHTML += `<div class='fc-other'><span class="fa fa-circle-o-notch"></span>${this.appConfig.getStatusLabel(info.event.extendedProps.serviceStatusID)}</div>`;
        }
        if (info.event.extendedProps.serviceTypes) {
          info.el.firstChild.innerHTML += `<div class='fc-other'><span class="fa fa-shopping-basket"></span>${info.event.extendedProps.serviceTypes
            .map((x) => {
              return x.serviceTypeName;
            })
            .join(', ')}</div>`;
        }
      }
      if (info.event.extendedProps.reservationStatus) {
        info.el.firstChild.innerHTML += `<div class='fc-other fc-status'>${info.event.extendedProps.reservationStatus}</div>`;
      }
    }
  }

  setCalendarRefresh() {
    setTimeout(() => {
      this.nowTime = new Date();
      if (this.calendarApi && this.calendarApi.view) {
        this.calendarApi.refetchEvents();
        this.setCalendarRefresh();
      }
    }, 300000);
  }

  getNowDate() {
    return moment(this.nowTime).format('YYYY-MM-DDTHH:mm:ss');
  }

  private readonly HEALTHY_THRESHOLD = 75;
  private readonly WARNING_THRESHOLD = 80;
  private readonly SERVICE_DUE_THRESHOLD = 100;

  renderResource(info) {
    info.el.firstChild.innerHTML = `<div class="fc-cell-content clickable" id="rentalTitle_${info.resource.id}">
    <span class="fc-cell-text product-name">
    ${info.resource.extendedProps.brand} ${info.resource.extendedProps.model}
    </span></div>`;

    if (info.resource.extendedProps.statusID == 40) {
      info.el.firstChild.innerHTML += `<div class="fc-cell-content" style="margin-top: -18px; padding-bottom: 0px;">
      <span class="fc-cell-text" style='color:red;font-weight:600;'>
      ${this.translate.instant('bikeshop.rentals.products.repair_needed')}
      </span></div>`;
    }

    if (info.resource.extendedProps.serviceIndicatorStatus) {
      info.el.firstChild.innerHTML += `<div class="service-indicator-status">
        <span class="fa ${info.resource.extendedProps.serviceIndicatorStatus >= this.SERVICE_DUE_THRESHOLD ? 'fa-wrench' : info.resource.extendedProps.serviceIndicatorStatus < this.SERVICE_DUE_THRESHOLD && info.resource.extendedProps.serviceIndicatorStatus >= this.HEALTHY_THRESHOLD ? 'fa-circle' : 'fa-circle-o'} ${info.resource.extendedProps.serviceIndicatorStatus >= this.SERVICE_DUE_THRESHOLD ? 'needs-service' : info.resource.extendedProps.serviceIndicatorStatus < this.SERVICE_DUE_THRESHOLD && info.resource.extendedProps.serviceIndicatorStatus >= this.HEALTHY_THRESHOLD ? 'approaching' : ''}"></span>
        </div>`;
    }

    if (info.resource.extendedProps.serialNumber) {
      info.el.firstChild.innerHTML += `<div class="fc-cell-content" style="margin-top: -18px; padding-bottom: 0px;">
      <span class="fc-cell-text">
      ${info.resource.extendedProps.serialNumber || ''}
      </span></div>`;
    }

    if (!this.hideProductImages) {
      info.el.firstChild.innerHTML += `<div class="fc-cell-content" style="margin-top: -18px;">
      <span class="fc-cell-text">
      ${info.resource.extendedProps.color || ''}  (${info.resource.extendedProps.size || ''})
      </span></div>`;

      info.el.firstChild.innerHTML += `<div id="rentalImage_${info.resource.id}" class="fc-cell-content rental-product-image" style="margin-top: -18px;">
        <div>
          <img src="${info.resource.extendedProps.imageURL ? info.resource.extendedProps.imageURL : '/assets/no-image-placeholder.png'}">
        </div>
      </div>`;
    }

    var div_conf = document.getElementById('rentalImage_' + info.resource.id);
    if (div_conf != null) {
      var _this = this;
      div_conf.onclick = function () {
        _this.selectedProduct = { id: info.resource.id };
        _this.showRentalProduct = true;
      };
    }

    var div_conf = document.getElementById('rentalTitle_' + info.resource.id);
    if (div_conf != null) {
      var _this = this;
      div_conf.onclick = function () {
        _this.selectedProduct = { id: info.resource.id };
        _this.showRentalProduct = true;
      };
    }
  }

  datesRender(event) {
    if (this.rentalProducts && this.rentalProducts.length > 0) {
      this.setBusinessHours(this.rentalProducts);
      this.rentalsService
        .getReservationCalendarOverrideStoreTimes(
          this.partnerID,
          moment(event.view.currentStart).format('YYYY-MM-DD'),
          moment(event.view.currentEnd).format('YYYY-MM-DD'),
        )
        .subscribe((res) => {
          if (
            res &&
            res.overrideStoreTimes &&
            res.overrideStoreTimes.length > 0
          ) {
            this.setCustomBusinessHours(res.overrideStoreTimes);
          }
          var tmp = JSON.parse(JSON.stringify(this.rentalProducts));
          this.rentalProducts = [];
          this.rentalProducts = tmp;
          this.calendarApi.refetchResources();
        });
    }
  }

  openSearchResult(result) {
    var reservation = { ...result, id: result.reservationID };
    this.selectedReservation = reservation;
    this.showRentalReservation = true;
  }

  refreshCalendar() {
    this.showBookRentalReservation = false;
    if (this.calendarApi && this.calendarApi.view) {
      this.calendarApi.refetchEvents();
    }
  }

  reservationClicked(event) {
    if (event.event.extendedProps.reservationNumber) {
      var reservation = {
        ...event.event.extendedProps,
        id: parseInt(event.event.id),
      };
      this.selectedReservation = reservation;
      this.showRentalReservation = true;
    }
  }

  search() {
    if (this.selectedSearchOption === 'JOBCARD') {
      var searchData = {
        Email: this.searchRequest,
        PhoneNumber: this.searchRequest,
        Customer: this.searchRequest,
        ReservationNumber: this.searchRequest,
      };
      this.searching = true;
      this.rentalsService
        .searchReservations(this.partnerID, searchData)
        .subscribe(
          (results) => {
            this.searchResults = results;
            this.searching = false;
          },
          (err) => {
            this.searching = false;
          },
        );
    } else if (this.selectedSearchOption === 'PRODUCTS') {
      this.rentalProducts = this.rentalProductsRaw;
      this.rentalProducts = this.rentalProducts.filter((x) => {
        return (
          x.extendedProps.serialNumber !== null &&
          x.extendedProps.serialNumber !== undefined &&
          x.extendedProps.serialNumber
            .toUpperCase()
            .indexOf(this.searchRequest.toUpperCase()) > -1
        );
      });
    }
  }

  clearSearch() {
    this.enableSearch = !this.enableSearch;
    this.clearSearchData();
    if (this.enableSearch) {
      setTimeout(() => {
        this.searchElement.nativeElement.focus();
      }, 200);
    }
  }

  clearSearchData() {
    this.searchRequest = '';
    this.searchResults = [];
    this.rentalProducts = this.rentalProductsRaw;
  }

  closeRentalProduct() {
    this.showRentalProduct = false;
  }

  getAffiliates() {
    this.rentalsService
      .getRentalAffiliates(this.helpersService.getPartnerId())
      .subscribe(
        (affiliates: any) => {
          this.affiliates = affiliates;
        },
        (err) => { },
      );
  }
}
